// excelExport.js
const tableToExcel = (function() {
    const uri = 'data:application/vnd.ms-excel;base64,';
    const template = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
    <head>
    <!--[if gte mso 9]>
    <xml>
        <x:ExcelWorkbook>
            <x:ExcelWorksheets>
                <x:ExcelWorksheet>
                    <x:Name>{worksheet}</x:Name>
                    <x:WorksheetOptions>
                        <x:DisplayGridlines/>
                    </x:WorksheetOptions>
                </x:ExcelWorksheet>
            </x:ExcelWorksheets>
        </x:ExcelWorkbook>
    </xml>
    <![endif]-->
    </head>
    <body>
        <table>{table}</table>
    </body>
    </html>`;

    const base64 = (s) => window.btoa(unescape(encodeURIComponent(s)));

    const format = (s, c) => s.replace(/{(\w+)}/g, (m, p) => c[p]);

    return function(tableId, worksheetName) {
        const table = document.getElementById(tableId);
        if (!table) {
            console.error(`Table with ID '${tableId}' not found.`);
            return;
        }
        const ctx = {
            worksheet: worksheetName || 'Worksheet',
            table: table.innerHTML
        };
        const excelURI = uri + base64(format(template, ctx));
        window.location.href = excelURI;
    };
})();

export default tableToExcel;
